import { getAuth } from "functions/BaseAxios";

export const NOTIFICATION_LIST = 'NOTIFICATION_LIST';
export const NOTIFICATION_LIST_ALL = 'NOTIFICATION_LIST_ALL';
export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT';

export function getNotification() {

    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await getAuth(`auth/notification?limit=6`);
        } catch (error) {
            data = { code: 201 };
        }
        dispatch({
            type: NOTIFICATION_COUNT,
            payload: data.code == 200 ? data.payload.count : 0,
        });

        dispatch({
            type: NOTIFICATION_LIST,
            payload: data.code == 200 ? data.payload.data : null,
        });
    }
}

export function getNotificationAll(start?: any, params?: any) {

    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await getAuth(`auth/notification?start=${start == undefined ? 0 : start}`);
        } catch (error) {
            data = { code: 201 };
        }

        let list;
        if (params) {
            list = params;
            if (data.code == 200) {
                data.payload.data.map((item: any, index: any) => {
                    list.push(item)
                })
            }
            if (data.payload.data.length == 0) {
                updateShowItemList(getShowItemList() - 1);
            }
        }

        dispatch({
            type: NOTIFICATION_LIST_ALL,
            payload: data.code == 200 ? params ? list : data.payload.data : [],
        });
    }
}

let numberPage = 0;
export function updateShowItemList(val: number) {
    numberPage = val;
}

export function getShowItemList() {
    return numberPage;
}
